import { render, staticRenderFns } from "./SupplierGeneralInfo.vue?vue&type=template&id=a8025c52&scoped=true&"
import script from "./SupplierGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./SupplierGeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./SupplierGeneralInfo.vue?vue&type=style&index=0&id=a8025c52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8025c52",
  null
  
)

export default component.exports